import st from './RadioButton.module.scss';
import { memo } from "react";

type RadioType = {
    value?: any;
    onChange?: (obj: any) => void;
    isChecked?: boolean
    onClick?: any
    name?: any
    id?: any
}

function RadioButton({ value = '', onChange, isChecked = false, onClick, name = '', id = '' }: RadioType) {
    return (
        <>
            <input type={"radio"} className={st.radio} name={name} value={value} checked={isChecked} id={id} onClick={onClick}
                onChange={onChange ? onChange : () => {
                    return;
                }} />
        </>
    );
}

export default memo(RadioButton)
